module.exports = __webpack_public_path__ + "img/RedteaSIM 首图手机@2x.5f27886f.png";